import "./App.css";
import { Route, Routes } from "react-router-dom";
import { UserLogin } from "./components/user/UserLogin";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ChangeLogs from "./components/pages/ChangeLogs";
import PageNotFound from "./components/pages/pageNotFound";
import Feeds from "./components/pages/Feeds";
// import Filters from "./components/pages/Filters";
import Videos from "./components/pages/Videos";
import UploadVideo from "./components/pages/UploadVideo";
import React, { useState, useEffect } from 'react'
// import ProtectedRoutes from "./ProtectedRoutes";
import Protected from "./Protected";
import UserDetails from "./components/pages/UserDetails";


function App() {
  const [isSignedIn, setIsSignedIn] = useState(sessionStorage.getItem('isSignedIn') === 'true')


  const signin = () => {
    setIsSignedIn(true)
    sessionStorage.setItem('isSignedIn', 'true')
  }

  const signout = () => {
    setIsSignedIn(false)
    sessionStorage.setItem('isSignedIn', 'false')
  }

  useEffect(() => {
    if (sessionStorage.getItem('isSignedIn') === null) {
      sessionStorage.setItem('isSignedIn', 'false')
    }
  }, [])

  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={3000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />

      <Routes>
        <Route path="/" element={<UserLogin signin={signin} />} />
        <Route path="/login" element={<UserLogin signin={signin} />} />
        <Route path="/*" element={<PageNotFound />} />

       
        <Route path="/logs"
          element={
            <Protected isSignedIn={isSignedIn}>
              <ChangeLogs signin={signin} signout={signout} />
            </Protected>
          } />
        
        <Route path="/feeds"
          element={
            <Protected isSignedIn={isSignedIn} >
              <Feeds signin={signin} signout={signout} />
            </Protected>
          } />
        
        <Route path="/videos"
          element={
            <Protected isSignedIn={isSignedIn} >
              <Videos signin={signin} signout={signout} />
            </Protected>
          } />
          <Route path="/users"
          element={
            <Protected isSignedIn={isSignedIn} >
              <UserDetails signin={signin} signout={signout} />
            </Protected>
          } />
          <Route path="/upload"
          element={
            <Protected isSignedIn={isSignedIn} >
              <UploadVideo signin={signin} signout={signout} />
            </Protected>
          } />
        <Route path="/logout"
          element={
            <Protected isSignedIn={isSignedIn}>
              <UserLogin />
            </Protected>
          } />
      </Routes>
    </div>
  );
}

export default App;
